import React from 'react';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { Navigate, useLocation } from 'react-router-dom';

const RequireAuth: React.FC = ({ children }) => {
  const token = useAppSelector((state) => state.auth.token);
  const location = useLocation();

  // Remember where they were headed (e.g. a feedback link from Slack) so login
  // can send them back there instead of to the dashboard.
  return token ? (
    <>{children}</>
  ) : (
    <Navigate to="/auth/login" replace state={{ from: location.pathname + location.search }} />
  );
};

export default RequireAuth;
